import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory, Link } from 'react-router-dom';
import { Box, Typography, Button, TextField, Stack, Alert } from '@mui/material';
import BlogsIcon from './BlogsIcon';
import { color, font } from '../styles/tokens';

const Register = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [fieldError, setFieldError] = useState('');
  const [serverError, setServerError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const history = useHistory();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, []);

  const validate = () => {
    if (!username.trim()) return 'Enter a username.';
    if (password.length < 6) return 'Password must be at least 6 characters.';
    if (password !== confirmPassword) return 'Passwords don’t match.';
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerError('');

    const validationMessage = validate();
    setFieldError(validationMessage);
    if (validationMessage) return;

    setSubmitting(true);
    try {
      await axios.post('/api/auth/register', { username: username.trim(), password });
      history.push('/Enteria', { message: 'Account created. Sign in below.' });
    } catch (err) {
      setServerError(err?.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh', width: '100vw', position: 'relative',
        display: 'grid', placeItems: 'center', overflow: 'hidden',
        background: `radial-gradient(900px 420px at 18% 92%, ${color.cyanGlow}, transparent 60%), ${color.ink}`,
      }}
    >
      <Box
        className="wd-bracket"
        sx={{
          position: 'relative', zIndex: 1, width: 'min(380px, 90vw)',
          background: color.glass, backdropFilter: 'blur(14px)', WebkitBackdropFilter: 'blur(14px)',
          border: `1px solid ${color.cyanDim}`, p: { xs: 3, sm: 4 },
          filter: `drop-shadow(0 0 26px ${color.cyanGlow}) drop-shadow(0 24px 50px rgba(0,0,0,.55))`,
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Box sx={{ width: 48, height: 48, borderRadius: '50%', background: '#fff', display: 'grid', placeItems: 'center', overflow: 'hidden' }}>
            <BlogsIcon style={{ width: 48, height: 48, borderRadius: 0, boxShadow: 'none' }} />
          </Box>
        </Box>
        <Typography sx={{ fontFamily: font.mono, fontSize: '.6875rem', letterSpacing: '.14em', textTransform: 'uppercase', color: color.cyan, textAlign: 'center', mb: 1 }}>
          New credential
        </Typography>
        <Typography sx={{ fontFamily: font.display, fontWeight: 600, fontSize: '1.35rem', color: color.bone, textAlign: 'center', mb: 3 }}>
          Create your account
        </Typography>
        {(fieldError || serverError) && (
          <Alert severity="error" sx={{ mb: 2 }}>{fieldError || serverError}</Alert>
        )}
        <form onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <TextField
              label="Username"
              value={username}
              onChange={e => setUsername(e.target.value)}
              fullWidth
              required
              autoFocus
            />
            <TextField
              label="Password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              helperText="At least 6 characters"
              fullWidth
              required
            />
            <TextField
              label="Confirm password"
              type="password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              fullWidth
              required
            />
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={submitting}>
              {submitting ? 'Creating account…' : 'Create account'}
            </Button>
          </Stack>
        </form>
        <Typography variant="body2" sx={{ mt: 3, textAlign: 'center', color: color.boneFaint }}>
          Already have an account? <Link to="/Enteria" style={{ color: color.cyan }}>Sign in</Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default Register;
